import React from 'react'
import { inject, observer } from 'mobx-react'
import TargetGroup from './TargetGroup'
import { withTranslation } from 'react-i18next'

const SharedTargetGroupListContents = ({ dataStore, t }) => (
  dataStore.sharedTargetGroups.length > 0
    ? (
      <ul className='unstyled nested-list target-group-list'>
        {
          dataStore.sharedTargetGroups.map(group => (
            <TargetGroup key={group.pk} group={group} />
          ))
        }
      </ul>
      )
    : (
      <p className='note'>{t('TARGET_GROUP.NO_SHARED_GROUPS')}</p>
      )
)

export default withTranslation()(inject('dataStore')(observer(SharedTargetGroupListContents)))
